"use client";
import AboutHeroSection from "@/components/AboutHeroSection";
import React, { useEffect, useRef } from "react";
import services from "../../public/assets/images/services/services.png";
import MobileAppDevelopment from "../../public/assets/images/services/Mobile-App-Development.png";
import uiUx from "../../public/assets/images/services/uiux.png";
import website from "../../public/assets/images/services/website-development.png";
import backend from "../../public/assets/images/services/backend-service.png";
import database from "../../public/assets/images/services/database-service.png";
import cloud from "../../public/assets/images/services/cloud-service.png";
import aiml from "../../public/assets/images/services/ai-ml-service.png";
import "../app/services/services.css";
import Technologies from "@/components/Technologies";
import { Col, Container, Row } from "react-bootstrap";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import CommonButton from "@/components/CommonButton";
import Link from "next/link";

const ServicesPage = () => {
  const mobileRef = useRef(null);
  const websiteRef = useRef(null);
  const uiRef = useRef(null);
  const digitalRef = useRef(null);
  const softwareRef = useRef(null);
  const pathname = usePathname();

  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    const scrollToSection = () => {
      if (hash === "web" && websiteRef.current)
        websiteRef.current.scrollIntoView({ behavior: "smooth" });
      if (hash === "mobile" && mobileRef.current)
        mobileRef.current.scrollIntoView({ behavior: "smooth" });
      if (hash === "ui" && uiRef.current)
        uiRef.current.scrollIntoView({ behavior: "smooth" });
      if (hash === "software" && softwareRef.current)
        softwareRef.current.scrollIntoView({ behavior: "smooth" });
      if (hash === "digital" && digitalRef.current)
        digitalRef.current.scrollIntoView({ behavior: "smooth" });
    };
    setTimeout(scrollToSection, 100);
  }, [pathname]);

  useEffect(() => {
    const reveal = () => {
      const reveals = document.querySelectorAll(".reveal");

      reveals.forEach((element) => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 10;

        if (
          elementTop < windowHeight - elementVisible &&
          !element.classList.contains("active")
        ) {
          element.classList.add("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal(); // trigger on load

    return () => window.removeEventListener("scroll", reveal);
  }, []);

  const ServiceSection = ({
    title,
    highlight,
    content,
    image,
    reverse,
    id,
    sectionRef,
    link = "#",
  }) => (
    <Row className={`gy-4 mb-5 ${id}`} ref={sectionRef} id={id}>
      {reverse ? (
        <>
          <Col lg={6} md={12} className="align-self-center responsive-order-2">
            <h3 className="com-title reveal fade-left">
              {title} <span>{highlight}</span>
            </h3>
            {content.map((text, index) => (
              <p className="reveal fade-bottom" key={index}>
                {text}
              </p>
            ))}
            <div className="reveal fade-bottom">
              <Link href={link} aria-label={`View in Detail`}>
                <CommonButton
                  label="Read More"
                  className="btn-primary "
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      style={{ height: "20px" }}
                    >
                      <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                    </svg>
                  }
                />
              </Link>
            </div>
          </Col>
          <Col
            lg={6}
            md={12}
            className="align-self-center reveal fade-right responsive-order-1"
          >
            <Image
              src={image}
              alt="about-img"
              height={500}
              width={500}
              className="img-fluid mx-auto d-block"
            />
          </Col>
        </>
      ) : (
        <>
          <Col lg={6} md={12} className="align-self-center reveal fade-left">
            <Image
              src={image}
              alt="about-img"
              height={500}
              width={500}
              className="img-fluid mx-auto d-block"
            />
          </Col>
          <Col lg={6} md={12} className="align-self-center">
            <h3 className="com-title reveal fade-right">
              {title} <span>{highlight}</span>
            </h3>
            {content.map((text, index) => (
              <p className="reveal fade-bottom" key={index}>
                {text}
              </p>
            ))}
            <div className="reveal fade-bottom">
              <Link href={link} aria-label={`View in Detail`}>
                <CommonButton
                  label="Read More"
                  className="btn-primary "
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      style={{ height: "20px" }}
                    >
                      <path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                    </svg>
                  }
                />
              </Link>
            </div>
          </Col>
        </>
      )}
    </Row>
  );
  return (
    <>
      <AboutHeroSection
        pillText="~ Software Development Services ~"
        title="We are Solving problems with "
        highlight="technology"
        description="Accelerate your business with the best powerhouse of developers"
        imageAlt="Technology we use"
        image={services}
      />
      <section className="py-5 about-text">
        <Container>
          <ServiceSection
            sectionRef={mobileRef}
            title="Mobile App "
            highlight="Development"
            image={MobileAppDevelopment}
            id="mobile"
            content={[
              "At Neoverce IT Solutions, we specialize in building robust, user-friendly, and scalable mobile applications. Whether you're targeting Android, iOS, or both, our expert team crafts apps that align with your business goals and provide an exceptional user experience.",
            ]}
            link="/services/mobile-app-development"
          />

          <ServiceSection
            title="FrontEnd "
            highlight="Development"
            reverse
            image={website}
            id="website"
            content={[
              "We create fast, responsive, and visually compelling web interfaces using modern front-end technologies. Our focus is on delivering seamless user experiences through intuitive design, clean code, and performance optimization.",
            ]}
            link="/services/frontend"
          />

          <ServiceSection
            title="UI/UX Design"
            highlight="Design"
            image={uiUx}
            id="ui"
            content={[
              "Our UI/UX design services are centered on crafting beautiful, user-centric interfaces that enhance engagement and usability. From wireframes to high-fidelity prototypes, we ensure that every element supports your business objectives and delights your users.",
            ]}
            link="/services/uiux-design"
          />

          <ServiceSection
            title="BackEnd "
            highlight="Development"
            image={backend}
            id="backend"
            reverse
            content={[
              "Our backend development services ensure that your applications run securely, efficiently, and at scale. We build powerful server-side architectures, APIs, and databases to handle your data and business logic reliably and seamlessly.",
            ]}
            link="/services/backend"
          />

          <ServiceSection
            title="Database"
            highlight="Architecture"
            id="database"
            image={database}
            content={[
              "We design and implement robust, secure, and scalable database solutions tailored to your specific business needs. From relational databases to NoSQL systems, we ensure your data is structured, accessible, and optimized for performance.",
            ]}
            link="/services/database"
          />

          <ServiceSection
            title="Cloud  "
            highlight="Services"
            image={cloud}
            id="cloud"
            reverse
            content={[
              "Our cloud services help businesses transition smoothly to the cloud, enabling flexibility, scalability, and cost efficiency. We work with leading cloud platforms to deploy, manage, and optimize cloud infrastructure for your applications.",
            ]}
            link="/services/cloud-services"
          />

          <ServiceSection
            title="AI"
            highlight="/ML"
            id="ai"
            image={aiml}
            content={[
              "We deliver AI and Machine Learning solutions that empower businesses to automate processes, gain insights, and make data-driven decisions. From predictive analytics to intelligent automation, our team helps integrate smart technologies into your operations.",
            ]}
            link="/services/ai-ml"
          />
        </Container>
      </section>
      <Technologies />
    </>
  );
};

export default ServicesPage;
